import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Link } from 'react-router';
import { show } from 'redux-modal';
import pick from 'lodash/pick';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Ssp as Layout } from '../../components/layouts';
import {
  SspWebDashboard,
  SspWebFeedReport,
  SspWebAdReport,
  SspWebPixel,
  SspWebSettings,
  SspWebFeedSettings,
  SspWebFeedManager,
  ErrorPage,
  Initializing
} from '../../views';

class Website extends Component {

  componentDidMount() {
    if (this.props.notFound) this.redirectNotFound();
  }

  componentDidUpdate() {
    if (this.props.notFound) this.redirectNotFound();
  }

  redirectNotFound() {
    this.props.dispatch(push('/404'));
  }

  activeRoute(regex) {
    const { location: { pathname } } = this.props;
    return regex.test(pathname) ? 'active' : null;
  }

  nestedActiveRoute(path) {
    const { location: { pathname } } = this.props;
    return path === pathname ? 'active' : null;
  }


  handleSettings() {
    const { dispatch, website } = this.props;
    dispatch(show('WebsiteFormModal', {
      website,
      heading: `Website Settings - ${website.name}`,
      formAction: 'Update'
    }));
  }

  renderPage() {
    const { website, routeParams: { websitePage } } = this.props;
    switch (websitePage) {
      case 'dashboard':
        return <SspWebDashboard website={website} />;
      case 'pixel':
        return <SspWebPixel website={website} />;
      case 'feed-report':
        return <SspWebFeedReport website={website} />;
      case 'ad-report':
        return <SspWebAdReport website={website} />;
      case 'settings':
        return <SspWebSettings website={website} />;
      case 'feed-settings':
        return <SspWebFeedSettings website={website} />;
      case 'feed-manager':
        return <SspWebFeedManager website={website} />;
      default:
        return (
          <ErrorPage
            location={this.props.location}
            noLayout
            errorCode='404'
            redirectTo={`/ssp/websites/${website.slug}/dashboard`}
          />
        );
    }
  }

  render() {
    const { website, isLoading } = this.props;
    const { slug, name } = website;
    const navItems = (
      <ul className="nav metismenu" id="side-menu" ref="menu">
        <li className={this.activeRoute(/dashboard/)}>
          <Link to={slug ? `/ssp/websites/${slug}/dashboard` : null}>
            <FontAwesomeIcon icon="tachometer-alt" /> Dashboard
          </Link>
        </li>
        <li className={this.activeRoute(/pixel/)}>
          <Link to={slug ? `/ssp/websites/${slug}/pixel` : null}>
            <FontAwesomeIcon icon="tag" /> Pixel
          </Link>
        </li>
        <li className={this.activeRoute(/ad-report/)}>
          <Link to={slug ? `/ssp/websites/${slug}/ad-report` : null}>
            <FontAwesomeIcon icon="bullhorn" /> Ad Report
          </Link>
        </li>
        <li className={this.activeRoute(/feed-report/)}>
          <Link to={slug ? `/ssp/websites/${slug}/feed-report` : null}>
            <FontAwesomeIcon icon="rss" /> Feed Report
          </Link>
        </li>
        <li className={this.activeRoute(/feed-manager/)}>
          <Link to={slug ? `/ssp/websites/${slug}/feed-manager` : null}>
            <FontAwesomeIcon icon="rss-square" /> Feed Manager
          </Link>
        </li>
        <li className={this.activeRoute(/settings|feed-settings/)}>
          <a href="javascript:void(0);">
            <FontAwesomeIcon icon="cogs" /> Settings
            <span className="fa arrow" />
          </a>
          <ul className="nav nav-second-level collapse">
            <li className={this.nestedActiveRoute(`/ssp/websites/${slug}/settings`)}>
              <Link to={slug ? `/ssp/websites/${slug}/settings` : null}>
                <span className="nav-label">General</span>
              </Link>
            </li>
            <li className={this.nestedActiveRoute(`/ssp/websites/${slug}/feed-settings`)}>
              <Link to={slug ? `/ssp/websites/${slug}/feed-settings` : null}>
                <span className="nav-label">Feed</span>
              </Link>
            </li>
          </ul>
        </li>
      </ul>
    );

    if (isLoading) {
      return (
        <Initializing />
      );
    }

    const passProps = pick(this.props, ['routeParams', 'location', 'routes']);
    passProps.routeParams.websiteName = name;

    return (
      <Layout
        {...passProps}
        navItems={navItems}
      >
        {this.renderPage()}
      </Layout>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { routeParams: { websitePage, websiteSlug } } = ownProps;
  const { ssp: { websites } } = state;
  const website = (websites.data.data || [])
    .filter((w) => w.slug === websiteSlug)[0] || {};
  const notFound = !['dashboard', 'pixel', 'feed-report', 'ad-report', 'settings', 'feed-settings', 'feed-manager'].includes(websitePage);
  return { website, notFound, isLoading: websites.loading };
};

export default connect(mapStateToProps)(Website);
